/* eslint-disable no-undef */
// utils
import OnScreen from 'onscreen';
import animateDock from '../utils/animate-dock';
import dockStartingState from '../utils/dock-starting-state';
// 3rd

const $ = jQuery;
const $window = $(window);

const dockHideAnimations = () => {
  const els = once('docks-static-main', '.p-st-docks');
  els.forEach((el) => {
    const $this = $(el);
    const $wrapper = $this.find('.pst-docks-wrapper');
    const $dockSelect = $this.find('select');
    let i;

    // On select change
    $dockSelect.on('change', function () {
      const selectVal = this.value;

      if (selectVal === 'show-all') {
        $wrapper.addClass('show-all');
        i = 1;
        // Loop through all docks and reset them to starting positions and show first 2 docks, the rest is on scroll.
        $this.find('.pst-docks-item svg').each(function () {
          // @todo: Ensure the SVG instance is adopted correctly for manipulation@todo
          const svg = SVG.adopt(el);
          const dockName = $(this).attr('id');
          const dockId = dockName.slice(dockName.length - 1);
          dockStartingState(dockId, svg);
          if (i <= 2) {
            // Animate first 2 docks off the selection since user won't be scrolling at that point
            animateDock(`dock_item_${dockId}`, svg);
            i += 1;
          }
        });
        $('.pst-docks-item').show(); // Show all elements if "show-all" options was selected
      } else {
        $wrapper.removeClass('show-all');
        $('.pst-docks-item').hide(); // Hide all elements (for rehiding elements when they have been chosen previously)
        const dockSelector = $(`#${selectVal}`);
        const dockId = selectVal.slice(selectVal.length - 1);
        // @todo: Adopt the SVG instance of the selected dock for animation
        const svg = SVG.adopt(dockSelector.find('.pst-dock-svg svg')[0]);
        dockStartingState(dockId, svg); // Reset to starting position if it has been animated before already
        dockSelector.show(); // Display only selected element
        animateDock(`dock_item_${dockId}`, svg);
      }
    });

    const dockHide = function () {
      $this.find('.pst-docks-item svg').each(function () {
        // @todo: Adopt each dock's SVG instance for resetting its state
        const svg = SVG.adopt($(this)[0]);
        const dockName = $(this).attr('id');
        const dockId = dockName.slice(dockName.length - 1);
        dockStartingState(dockId, svg);
      });
    };

    // Event: Hide docks when they scroll out of view
    $(window).scroll(function () {
      const topOfElement = $wrapper.offset().top;
      const bottomOfElement = $wrapper.offset().top + $wrapper.outerHeight();
      const bottomOfScreen = $(window).scrollTop() + $(window).innerHeight();
      const topOfScreen = $(window).scrollTop();

      if (bottomOfScreen > topOfElement && topOfScreen < bottomOfElement) {
        // Dock element is visible
        // Consider adding visual feedback or animations if required
      } else {
        dockHide(); // Reset docks when out of view
      }
    });
  });
};

const dockOnEnterAnimation = () => {
  const els = once('static-dom', '.p-st-docks .pst-dock-svg svg');
  els.forEach((el) => {
    const $this = $(el);
    const dockName = $this.attr('id');
    const dockId = dockName.slice(dockName.length - 1);

    // @todo: Adopt the SVG instance of each dock to reset its state and prepare for animation
    const svg = SVG.adopt(el);

    dockStartingState(dockId, svg);

    /// @todo: Set up on-screen monitoring for dock animations on scroll
    const os = new OnScreen({
      tolerance: 20,
      debounce: 20,
    });

    os.on('enter', `#pst-docks-${dockId}`, function () {
      animateDock(`dock_item_${dockId}`, svg);
    });
  });
};

$window.on('load', function () {
  dockHideAnimations();
  dockOnEnterAnimation();
});
